/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/main/LICENSE.md for details.
 * v1.9.2
 */
import { B as Button, d as defineCustomElement$1 } from './button.js';

const CalciteButton = Button;
const defineCustomElement = defineCustomElement$1;

export { CalciteButton, defineCustomElement };
